import { cn } from '@ui-kit/utils';
import type { IconProps } from '@/components/icons/types';

const IdProtectIcon = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={cn('size-6 shrink-0', className)}
    {...props}
  >
    <path
      d="M21.6626 14.208C22.0771 14.896 22.2543 15.7012 22.1668 16.4997V16.958C22.1662 17.4406 22.2927 17.9148 22.5334 18.333"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6665 16.0413C16.6665 15.5551 16.8597 15.0888 17.2035 14.745C17.5473 14.4012 18.0136 14.208 18.4998 14.208C18.9861 14.208 19.4524 14.4012 19.7962 14.745C20.14 15.0888 20.3332 15.5551 20.3332 16.0413V16.4997C20.3332 17.4914 20.6548 18.4563 21.2498 19.2497"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 16.042V16.9587C18.4985 18.2692 18.8984 19.5488 19.6458 20.6253"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6665 17.875C16.7787 18.8328 17.0579 19.7636 17.4915 20.625"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2457 19.7086C14.9364 18.6683 14.7971 17.5849 14.8332 16.5002V16.0419C14.8314 15.3974 14.9996 14.7639 15.3207 14.2051C15.6418 13.6463 16.1045 13.182 16.6622 12.859C17.2199 12.536 17.8529 12.3657 18.4974 12.3652C19.1419 12.3648 19.7751 12.5342 20.3332 12.8565"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0051 20.687C12.6721 20.806 12.3321 20.91 11.9871 21C10.4304 20.5962 8.97062 19.8836 7.69468 18.9045C6.41875 17.9254 5.35265 16.6998 4.55973 15.3005C3.76682 13.9013 3.26327 12.3569 3.07901 10.7592C2.89476 9.16147 3.03355 7.54302 3.48714 6C6.60267 6.14257 9.65131 5.06658 11.9871 3C14.323 5.06658 17.3716 6.14257 20.4871 6C20.9201 7.472 21.0621 8.998 20.9231 10.495"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IdProtectIcon;
